import { FhirService } from "@/common/api.service";
import {
  FETCH_FHIR_ORG_FOR_CLIENT_DATA, FETCH_FHIR_ORG_REG_DATA, FETCH_FHIR_ORG_DATA, FETCH_FHIR_PHYSICIAN_DATA, FETCH_FHIR_PATIENT_DATA,
  FETCH_FHIR_PHYSICIAN_MAPPING_DATA, FETCH_FHIR_PATIENT_MAPPING_DATA, UPDATE_FHIR_PATIENT_DATA,
  UPDATE_FHIR_PHYSICIAN_DATA, CREATE_FHIR_PATIENT_DATA, CREATE_FHIR_PHYSICIAN_DATA, RESET_STATE
} from "./actions.type";
import {
  SET_FHIR_ORG_FOR_CLIENT_DATA, SET_FHIR_REG_ORG_DATA, SET_FHIR_SEARCH_PHYSICIAN_DATA, SET_FHIR_PHYSICIAN_MAPPING_DATA,
  SET_FHIR_PATIENT_MAPPING_DATA, SET_FHIR_SEARCH_PATIENT_DATA, STATE_RESET, SET_FHIR_ERROR
} from "./mutations.type";

const initialState = () => {
  return {
    patientdata: [],
    physiciandata: [],
    fhirerror: {},
    organizationForClient: {},
    registeredOrganization: {},
    isPhysicianRegistered: {},
    isPatientRegistered: {}
  }
};

export const state = initialState();

const actions = {

  async [FETCH_FHIR_ORG_FOR_CLIENT_DATA](context, slug) {
    return await FhirService.create(slug.url, slug.params).then((response) => {
      context.commit(SET_FHIR_ORG_FOR_CLIENT_DATA, response.data)
      return response
    }).catch(error => {
      context.commit(SET_FHIR_ERROR, error.response.data.errorMessage)
      throw error
    })
  },

  async [FETCH_FHIR_ORG_REG_DATA](context, slug) {
    return await FhirService.get(slug.url, slug.params).then((response) => {
      context.commit(SET_FHIR_REG_ORG_DATA, response.data)
      return response
    }).catch(error => {
      context.commit(SET_FHIR_ERROR, error.response.data.errorMessage)
      throw error
    })
  },

  async [FETCH_FHIR_ORG_DATA](context, slug) {
    return await FhirService.get(slug.url, slug.params).then((response) => {
      context.commit(SET_FHIR_ORG_FOR_CLIENT_DATA, response.data)
      return response
    }).catch(error => {
      context.commit(SET_FHIR_ERROR, error.response.data.errorMessage)
      throw error
    })
  },

  async [FETCH_FHIR_PHYSICIAN_DATA](context, slug) {
    return await FhirService.get(slug.url, slug.params).then((response) => {
      context.commit(SET_FHIR_SEARCH_PHYSICIAN_DATA, response.data)
      return response
    }).catch(error => {
      context.commit(SET_FHIR_ERROR, error.response.data.errorMessage)
      throw error
    })
  },

  async [FETCH_FHIR_PATIENT_DATA](context, slug) {
    return await FhirService.get(slug.url, slug.params).then((response) => {
      context.commit(SET_FHIR_SEARCH_PATIENT_DATA, response.data)
      return response
    }).catch(error => {
      context.commit(SET_FHIR_ERROR, error.response.data.errorMessage)
      throw error
    })
  },

  async [FETCH_FHIR_PHYSICIAN_MAPPING_DATA](context, slug) {
    return await FhirService.get(slug.url, slug.params).then((response) => {
      context.commit(SET_FHIR_PHYSICIAN_MAPPING_DATA, response.data)
      return response
    }).catch(error => {
      context.commit(SET_FHIR_ERROR, error.response.data.errorMessage)
      throw error
    })
  },

  async [FETCH_FHIR_PATIENT_MAPPING_DATA](context, slug) {
    return await FhirService.get(slug.url, slug.params).then((response) => {
      context.commit(SET_FHIR_PATIENT_MAPPING_DATA, response.data)
      return response
    }).catch(error => {
      context.commit(SET_FHIR_ERROR, error.response.data.errorMessage)
      throw error
    })
  },

  async [UPDATE_FHIR_PATIENT_DATA](context, slug) {
    return await FhirService.update(slug.slug, slug.params).then((response) => {
      return response
    }).catch(error => {
      context.commit(SET_FHIR_ERROR, error.response.data.errorMessage)
      throw error
    })
  },

  async [UPDATE_FHIR_PHYSICIAN_DATA](context, slug) {
    return await FhirService.update(slug.slug, slug.params).then((response) => {
      return response
    }).catch(error => {
      context.commit(SET_FHIR_ERROR, error.response.data.errorMessage)
      throw error
    })
  },

  async [CREATE_FHIR_PATIENT_DATA](context, slug) {
    return await FhirService.create(slug.slug, slug.params).then((response) => {
      return response
    }).catch(error => {
      context.commit(SET_FHIR_ERROR, error.response.data.errorMessage)
      throw error
    })
  },

  async [CREATE_FHIR_PHYSICIAN_DATA](context, slug) {
    return await FhirService.create(slug.slug, slug.params).then((response) => {
      return response
    }).catch(error => {
      context.commit(SET_FHIR_ERROR, error.response.data.errorMessage)
      throw error
    })
  },

  // [RESET_STATE]({ commit }) {
  //   commit(STATE_RESET)
  // }

}

const mutations = {

  [SET_FHIR_ORG_FOR_CLIENT_DATA](state, data) {
    state.organizationForClient = data
  },

  [SET_FHIR_REG_ORG_DATA](state, data) {
    state.registeredOrganization = data
  },

  [SET_FHIR_PATIENT_MAPPING_DATA](state, data) {
    state.isPatientRegistered = data
  },

  [SET_FHIR_PHYSICIAN_MAPPING_DATA](state, data) {
    state.isPhysicianRegistered = data
  },

  [SET_FHIR_SEARCH_PHYSICIAN_DATA](state, data) {
    state.physiciandata = data
  },

  [SET_FHIR_SEARCH_PATIENT_DATA](state, data) {
    state.patientdata = data
  },

  [SET_FHIR_ERROR](state, error) {
    state.fhirerror = error
  },
  // [STATE_RESET](state) {
  //   console.log("STATE_RESET::", state)
  //   Object.assign(state, initialState())
  // }

}

const getters = {
  fhirpatientdata(state) {
    return state.fhirpatientdata;
  },
  fhirphysiciandata(state) {
    return state.fhirphysiciandata;
  },
  fhirorgdata(state) {
    return state.organizationForClient;
  }

}

export default {
  state,
  getters,
  actions,
  mutations
};